import React from 'react';
import { TopRightMenu } from '../NavMenus/TopNavigation';
import Logo from '../Common/Logo';

export default function CommonHeader({ className = 'common-header' }) {
  return (
    <section className={className}>
      <div className="header-content">
        <div>
          <Logo />
        </div>
        <div>
          <TopRightMenu renderizedBy='ApplyPage' />
        </div>
      </div>
    </section>
  );
}
